import React from "react";
import { connect } from "react-redux";
import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        loggedUser: store.loggedUser
    }
})

class FieldType extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            searchIsLoading: false
        }

        _.map(["onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onChange(e) {
        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "type", value: e }});
        }
    }

    render() {
        return (
            <Select 
                classes={{options: `workstreamType`}}
                placeholder="Select"
                options={[
                    { value: 4, label: "Output-based" },
                    { value: 5, label: "Time-based" }
                ]}
                onChange={ this.onChange }
                selected={ this.props.selected }
                isClose={ this.props.isClose }
                isFirstItemSelected={ false }
            />
        );
    }
}

export default FieldType;
